import { AfterViewInit, Component, HostListener, Inject, inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, } from '@angular/router';
import { SharedModule } from '../../../../shared/shared.module';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { CUSTOM_DATE_FORMATS } from '../../../../shared/models/CUSTOM_DATE_FORMATS';
import { userApi } from '../../../model/constants/endpoints';
import { PanelGuId, PanelId, RecaptchaSiteKey, SocialAccount } from '../../../model/constants/AppConstants';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../../services/common.service';
import { CompleteJoinProfileComponent } from '../complete-join-profile-component/complete-join-profile.component';
import { SharedService } from '../../../../services/shared.service';
import { ZipPattern } from '../../../model/constants/ZipPatterns';
import { ReCaptcha2Component } from 'ngx-captcha';
import { filter } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { TurnstileComponent } from '../../../../static-pages/turnstile/turnstile.component';
declare const google: any;
declare const window: any;
@Component({
  selector: 'app-join',
  standalone: true,
  imports: [SharedModule, TurnstileComponent],
  templateUrl: './join.component.html',
  providers: [
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
})
export class JoinComponent implements OnInit, AfterViewInit, OnDestroy {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private commonService: CommonService,
    private sharedService: SharedService,
    private activeRoute: ActivatedRoute,
  ) {
    this.getCulture()
  }
  @ViewChild('turnstile') turnstile!: TurnstileComponent;
  showPasswordFields: boolean = false;
  showConfirm: boolean;
  isError: boolean;
  isShowPassword: boolean;
  isPasswordNotMatch: boolean;
  opinionEdgeHearOption: any;
  firstName: string;
  userEmail: string;
  passwordField: any;
  reCaptcha: any;
  confirmPasswordField: any;
  ipAddress: string;
  gender: any;
  countryLanguage: any;
  signUpArray = [];
  countryId: number;
  languageId: number;
  trafficId: string;
  language: string;
  vistorId: string;
  sessionId: string;
  affiliateTrafficId: string;
  zipCountryId: any;
  zipPatternObjects: Array<ZipPattern> = [];
  regexForZip: any;
  acceptTerms: any;
  showZipErrorMessage: any;
  isSubmitAllowed: any;
  affilateid: string;
  transid: string;
  campid: string;
  scampid: string;
  referralCode: string;
  hearAboutQuestion: any;
  isFocused: boolean = false;
  statusCodeMap = require('../../../../core/model/constants/SCMapping.json');
  zipValidation = require('../../../../core/model/constants/ZipValidationPatterns.json');
  joinForm: FormGroup;
  isShowVerifyBox: boolean;
  isVPNCheck: boolean;
  currency: boolean;
  showCriteria: boolean;
  isLoading: boolean;
  passwordStrength: any;
  showMessage: any;
  isShowloader: boolean = false;
  isBlankPromo: boolean = false;
  isValidate: boolean = false;
  isPromoSuccess = false; // Reset success before calling API
  isPromoInvalid = false;
  promoAmount: number = 0;
  joiningBonus: number = 0;
  recaptchaSiteKey = RecaptchaSiteKey.siteKey;
  cultureLanguage: string;
  readonly dialog = inject(MatDialog);
  private verisoulLoadPromise: Promise<void> | null = null;
  @ViewChild(ReCaptcha2Component) captchaComponent: ReCaptcha2Component
  ngOnInit() {
    this.commanFunctions();
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: BeforeUnloadEvent): void {
    if (this.hasUnsavedChanges()) {
      $event.preventDefault();
      $event.returnValue = true; // Chrome ke liye required hai (empty string bhi chalta hai)
    }
  }
  private hasUnsavedChanges(): boolean {
    return this.joinForm && this.joinForm.dirty;
  }

  async getVarisoulSessionId() {
      this.sessionId = await this.commonService.userService.getVarisoulSessionId();
      if (!this.sessionId) {
        this.isLoading = false;
      }
  }

  ngAfterViewInit(): void {
    google.accounts.id.initialize({
      client_id: SocialAccount.googleClient_id,
      callback: (response: any) => this.handleGoogleSignIn(response),
    });

    const signInDiv = document.getElementById("googleSignInDiv");
    if (signInDiv) {
      google.accounts.id.renderButton(signInDiv, {
        theme: 'outline',
        size: 'large',
        type: 'standard',
        shape: 'pill',
        text: 'continue_with',
        logo_alignment: 'center',
      });
    }
  }


  // Callback Function for Google Sign-In
  async handleGoogleSignIn(response) {
    this.commonService.spinner.show();
    try {
      const body = {
        credential: response.credential,
        referral: undefined,
        panelGuid: PanelGuId.OpinionEdge,
        fcmToken: null,
        device: 3,
        visitorId: null,
        password: 'GoogleAuthUser@123'
      }
      this.commonService.httpApiService.post(userApi.continueWithGoogle, body).then((res: any) => {
        // Store user details in localStorage
        this.commonService.spinner.hide();
        if (res.success) {
          // Store user details in localStorage
          this.commonService.storageService.handleStoreData(res);
          // Redirect user to the desired page
          if (!res.data[0].isProfileComplete || res.requireAdditionalDetails) {
            this.openDialog();
            return;
            // this.router.navigate(['/complete-profile', { userId: response.data.data.user_id }]);
          }
          this.dialog.closeAll();
          this.commonService.router.navigate(['/dashboard']);
          window.scrollTo(0, 0);
        } else {
          console.error('Login failed:', res.message);
        }

      })
    } catch (error) {
      this.commonService.spinner.hide();
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(CompleteJoinProfileComponent);

    dialogRef.afterClosed().subscribe(result => {
    });
  }


  commanFunctions() {
    this.joiningBonus = Number(localStorage.getItem('joinBonus')) || 2;
    this.commonService.spinner.show()
    this.joinFormValue();
    this.valueChangePassword()
    this.handleSecurity();
  }

  ngOnDestroy() {

  }

  handleSecurity() {
    this.isShowloader = true;
    this.commonService.httpApiService.get(userApi.getSecurity).then(async (res: any) => {
      // id: 1- IPQS, 2- Varisoul
      const securityId = Number(res?.id);
      if (securityId === 2) {
        await this.getVarisoulSessionId()
      }
      this.getAffiliateDetails();
    }).catch((error: any) => {
      this.handleErrorResponse(error);
    })
  }


  async getVisitorId() {
    this.vistorId = await this.commonService.userService.getVistorId();
  }



  processSignup() {
    this.signupAnswers();
    this.updateFormValidation();
    if (this.joinForm.invalid) {
      this.joinForm.markAllAsTouched();
      return;
    }
  }

  clearVisitorData() {
    this.commonService.storageService.removeItem('visitorId');
  }

  createUserAccount(body: any) {
    this.commonService.httpApiService.post(userApi.createUser, body).then(async (res: any) => {
      this.isLoading = false
      this.handleUserCreationSuccess(res);
      this.turnstile.reset();
      // this.commonService.storageService.removeSessionItem('sessionId');
    }).catch((err) => {
      this.isLoading = false;
      this.turnstile.reset();
      this.handleErrorResponse(err);
    });
  }

  handleErrorResponse(err: any) {
    const mapStatusCode = this.getMappedStatusCode(err);
    if (!mapStatusCode) {
      this.setTranslatedMessage('somethingWentWrong');
      return;
    }
    this.isError = true;
    this.setTranslatedMessage(mapStatusCode);
  }

  private setTranslatedMessage(key: string): void {
    this.isShowloader = false
    this.commonService.translate.get(key).subscribe((translated: string) => {
      this.showMessage = translated;
    });
  }

  getMappedStatusCode(err: any) {
    return err?.statusCode ? this.statusCodeMap[0][err?.statusCode] : null;
  }

  handleUserCreationSuccess(res: any) {
    const userRes = res;
    this.isShowVerifyBox = true;
    const container = document.querySelector('.cdk-overlay-pane');
    container?.classList.remove('custom-dialog-container');
    this.commonService.translate.get('userCreate').subscribe((res: string) => {
      this.commonService.userService.showSuccess(res)
    });
    this.commonService.storageService.removeItems(['Ucountry', 'qusn', '_affiliateUrl', 'referralCode']);
    this.commonService.storageService.handleStoreData(userRes);
    // this.dialog.closeAll();
    this.commonService.router.navigate(['/dashboard']);
    window.scrollTo(0, 0)
  }

  validateForm(): boolean {
    if (this.passwordField.invalid || this.confirmPasswordField.invalid) {
      if (this.passwordField.hasError('minlength')) {
        this.commonService.translate.get('passChar').subscribe((res: string) => {
          this.commonService.userService.showError(res)
        });
      }
      if (this.confirmPasswordField.hasError('passwordMismatch')) {
        this.isPasswordNotMatch = true;
      }
      return false;
    }
     else if (this.reCaptcha.invalid) {
      this.commonService.translate.get('captchaValidation').subscribe((res: string) => {
        this.commonService.userService.showError(res)
      });
      return false;
    } 
    else if (this.acceptTerms.invalid) {
      this.commonService.translate.get('pleaseAccept').subscribe((res: string) => {
        this.commonService.userService.showError(res)
      });
      return false;
    }
    return true;
  }

  updateFormValidation(): void {
    this.setFieldValidators();
    this.updateFieldValidity();
    this.handlePasswordErrors();
  }

  private setFieldValidators(): void {

    this.passwordField.setValidators([
      Validators.required,
      Validators.minLength(8),
      this.strongPasswordValidator.bind(this)
    ]);

    this.confirmPasswordField.setValidators([
      Validators.required,
      this.matchPasswordValidator.bind(this)
    ]);

    this.acceptTerms.setValidators([Validators.requiredTrue]);
    this.reCaptcha.setValidators([Validators.required]);
  }

  private updateFieldValidity(): void {
    [
      this.passwordField,
      this.confirmPasswordField,
      this.acceptTerms,
      this.reCaptcha
    ].forEach(control => control.updateValueAndValidity());
  }

  private handlePasswordErrors(): void {
    if (this.passwordField.invalid || this.confirmPasswordField.invalid) {
      if (this.passwordField.hasError('required')) {
        this.isPasswordNotMatch = true;
        return;
      }

      if (this.confirmPasswordField.hasError('passwordMismatch')) {
        this.isPasswordNotMatch = true;
      }
      return;
    }
  }

  // Method for get selected languageId & countryId
  onLanguageSelect(event) {
    const value = event.target.value
    const countryId = this.countryLanguage.find(item => item.countryLanguage === value)
  }

  matchPasswordValidator(control: FormControl): { [key: string]: boolean } | null {
    if (!this.joinForm) return null;
    const password = this.joinForm?.get('password')?.value;
    const confirmPassword = control.value;

    if (password !== confirmPassword) {
      return { passwordMismatch: true };
    }
    return null;
  }


  closeDialog() {
    this.dialog.closeAll();
  }

  viewPassword() {
  }

  openPassword() {
    this.isShowPassword = !this.isShowPassword;
  }

  openConfirmPassword() {
    this.showConfirm = !this.showConfirm;
  }

  goBack() {
    const controlsToReset = [
      this.passwordField,
      this.confirmPasswordField,
      this.reCaptcha,
      this.acceptTerms
    ];

    controlsToReset.forEach(control => {
      control.clearValidators();
      control.updateValueAndValidity();
    });

    this.joinForm.markAsUntouched();
    this.joinForm.markAsPristine();

    this.showPasswordFields = false;
  }

  getIpAddress() {
    this.commonService.httpApiService.get(userApi.ipAddress).then((res: any) => {
      this.ipAddress = res.IP;
    }).catch((err: any) => {

    })
  }

  signupAnswers() {
    const joinFormValues = this.joinForm.value;
    const { firstName, lastName, zipCode, gender, opinionEdgeHear } = joinFormValues;

    this.signUpArray.forEach((element: any) => {
      const { qsnShortForm, option } = element;

      // Handle specific cases with a map for quicker lookup
      const handlers: Record<string, () => void> = {
        'Full Name': () => {
          element.firstName = firstName;
          element.lastName = lastName;
        },
        'Zip': () => {
          element.answerKey = zipCode?.replace(/\s/g, '')?.toUpperCase();
        },
        'DOB': () => {
          element.answerKey = this.getFormattedDate();
        },
        'GENDER': () => {
          element.answerKey = gender;
          option.forEach((genderKey: any) => {
            genderKey.isSelected = genderKey.optionStatement === gender;
          });
        },
        'STANDARD_Opinion Edge': () => {
          element.answerKey = opinionEdgeHear;
          option.forEach((opinionHear: any) => {
            opinionHear.isSelected = opinionHear.optionStatement === opinionEdgeHear;
          });
        },
      };

      if (handlers[qsnShortForm]) {
        handlers[qsnShortForm]();
      }

    });

  }


  getFormattedDate(): string {
    // const rawDate = this.joinForm.get('dob')?.value;
    // if (!rawDate) return '';

    // const date = new Date(rawDate); // Convert string to Date
    // if (isNaN(date.getTime())) return ''; // Invalid date check

    // const day = this.sharedService.padZero(date.getDate()) || '01';
    const month = this.formatMonth(this.joinForm.get('getMonth')?.value);
    const year = this.joinForm.get('getYear')?.value;
    // return `${month}/${day}/${year}`; // MM/DD/YYYY
    return `${year}-${month}-${'01'}`; // MM/DD/YYYY
  }

  formatMonth(month: number): string {
    return month < 10 ? `0${month}` : month.toString();
  }

  // getCountryDetails(countryLanguage?: any) {
  //   this.countryId = countryLanguage?.countryId;
  //   this.languageId = countryLanguage?.languageId;
  //   this.language = countryLanguage?.countryLanguage;
  //   this.trafficId = countryLanguage?.trafficId;
  //   this.affiliateTrafficId = countryLanguage?.affiliateTrafficId;

  // }

  // getCountryLanguage() {
  //   const affiliateUrl = isPlatformBrowser(this.platformId) ? location.origin + `/#/join?affid=${this.affilateid}&tid=${this.transid}&campid=${this.campid}&scampid=${this.scampid}` : ''
  //   //Method for  Get CountryLanguage
  //   const body = {
  //     panelId: PanelId.OpinionEdge,
  //     panelGuid: PanelGuId.OpinionEdge,
  //     affId: this.affilateid,
  //     tId: this.transid,
  //     campId: this.campid,
  //     subCampId: this.scampid,
  //     device: 3,
  //     affiliateUrl,
  //   }
  //   this.commonService.httpApiService.post(userApi.getCountryLanguage, body).then((res: any) => {
  //     this.countryLanguage = res.data ? res.data : [res];
  //     this.getCountryDetails(this.countryLanguage[0]);
  //   }).catch((error: any) => {
  //     this.handleErrorResponse(error);
  //   })
  // }

  async getSignUpQuestion() {
    const bodyRequest = {
      referral: this.commonService.storageService.getSessionItem('referralCode'),
      affiliate: {
        affiliateCode: this.affilateid,
        tId: this.transid,
        campId: this.campid,
        subCampId: this.scampid
      },
      device: 3,
      sessionId: this.sessionId,
      affiliateUrl: window.location.href
    }
    try {
      const response: any = await this.commonService.httpApiService.post(userApi.getSignupQsnViaLanguage, bodyRequest);
      this.setSignupQuestionArray(response);
      this.isShowloader = false;
    } catch (error) {
      this.handleErrorResponse(error);
    }
  }

  getAffiliateDetails() {
    // Method for affilate user
    this.activeRoute.queryParams.subscribe(params => {
      this.affilateid = params['affid'] || null;
      this.transid = params['tid'] || null;
      this.campid = params['campid'] || null;
      this.scampid = params['scampid'] || null;
      if (this.affilateid || this.transid || this.campid || this.scampid) {
        this.commonService.storageService.setSessionItem("_affiliateUrl", window.location.search.substring(1));
      }
    });

    this.activeRoute.params.subscribe(params => {

      const newReferralCode = params['id'];
      if (newReferralCode) {
        this.commonService.storageService.setSessionItem("referralCode", newReferralCode);
        this.referralCode = newReferralCode;
        return;
      }
    });

    this.getSignUpQuestion();
  }

  setSignupQuestionArray(qsns) {

    this.commonService.spinner.hide();
    this.signUpArray = qsns?.signupQsn;
    this.countryId = qsns?.countryId
    this.languageId = qsns?.languageId
    this.affiliateTrafficId = qsns?.affiliateTrafficId;
    this.trafficId = qsns?.trafficId;
    this.isVPNCheck = qsns?.isVPNCheck;
    this.currency = qsns?.currency;
    this.gender = qsns?.signupQsn?.find((qsn: any) => qsn.qsnShortForm === 'GENDER');
    this.hearAboutQuestion = qsns?.signupQsn?.filter((qsn: any) => qsn.qsnShortForm === 'STANDARD_Opinion Edge');
    if (this.hearAboutQuestion.length > 0) {
      this.joinForm?.get('opinionEdgeHear').addValidators(Validators.required)
      this.joinForm?.get('opinionEdgeHear').updateValueAndValidity()
    }
    this.opinionEdgeHearOption = this.hearAboutQuestion[0]?.option;
  }

  createJoinRequestBody(formValues: any) {
    const requestBody: any = {
      email: formValues.email,
      password: formValues.password,
      fcmToken: null,
      device: 3,
      visitorId: this.vistorId ?? null,
      panelId: PanelId.OpinionEdge,
      ipAddress: this.ipAddress,
      referral: this.commonService.storageService.getSessionItem('referralCode'),
      countryId: this.countryId,
      languageId: this.languageId,
      tId: this.transid,
      campId: this.campid,
      subCampId: this.scampid,
      isVPNCheck: this.isVPNCheck,
      currency: this.currency,
      trafficId: this.trafficId,
      signupQsn: this.signUpArray,
      promoCode: formValues.promoCode,
      affiliateTrafficId: this.affiliateTrafficId || null,
      appType: 10,
      sessionId: this.sessionId,
      v: formValues.reCaptcha,
      referralUrl: window.location.href
    };
    if (!requestBody.visitorId) delete requestBody.visitorId;
    if (!requestBody.promoCode || !this.isPromoSuccess) delete requestBody.promoCode;
    return requestBody;
  }

  onProceedClick(): void {
    this.readInput();
    if (this.joinForm.invalid) {
      this.joinForm.markAllAsTouched();
      return;
    }
    this.onZipValidation();
    if (this.isSubmitAllowed) {
      this.firstName = this.joinForm.get('firstName').value;
      this.userEmail = this.joinForm.get('email').value;
      this.showPasswordFields = true;
    } else {
      this.zipCodeError();
      this.joinForm.get('zipCode').reset()
      this.commonService.translate.get('zipValidInfoMessage').subscribe((translate) => {
        this.commonService.userService.showError(translate + this.zipPatternObjects[0].message)
      });
    }
  }

  joinFormValue() {
    const emailPattern = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    this.joinForm = this.commonService.fb.group({
      firstName: new FormControl('', [Validators.required, Validators.minLength(2), Validators.pattern(/^[A-Za-z]+$/)]),
      lastName: new FormControl('', [Validators.required, Validators.pattern(/^[A-Za-z]+$/)]),
      email: new FormControl('', Validators.compose([
        Validators.email,
        Validators.required,
        Validators.pattern(emailPattern)
      ])),
      opinionEdgeHear: new FormControl(''),
      getMonth: new FormControl('', Validators.required),
      getYear: new FormControl('', Validators.required),
      gender: new FormControl('', [Validators.required]),
      zipCode: new FormControl('', [Validators.required]),
      acceptTerms: new FormControl(false),
      password: new FormControl('',),
      confirmPassword: new FormControl('',),
      promoCode: new FormControl(''),
      reCaptcha: new FormControl(''),
    });

    this.passwordField = this.joinForm.get('password');
    this.confirmPasswordField = this.joinForm.get('confirmPassword');
    this.acceptTerms = this.joinForm.get('acceptTerms');
    this.reCaptcha = this.joinForm.get('reCaptcha');
  }

  async onSubmitJoinForm() {
    this.processSignup();
    const formValues = this.joinForm.value;

    if (this.validateForm()) {
      this.isLoading = true;
      await this.getVarisoulSessionId();
      await this.getVisitorId();
      const body = this.createJoinRequestBody(formValues);
      this.createUserAccount(body);
    }
  }

  onZipValidation() {
    this.zipPatternObjects = this.zipValidation.filter(e => e.countryids.find(l => l == this.countryId));
    this.regexForZip = new RegExp(this.zipPatternObjects[0].patterns[0]);
    const inputValue = this.joinForm.value.zipCode?.replace(/\s/g, "")?.toUpperCase()
    this.showZipErrorMessage = !this.regexForZip.test(inputValue);
    this.isSubmitAllowed = !this.showZipErrorMessage;
  }

  // Methor for getMonths
  getMonths(): string[] {
    const datePipe = new DatePipe('en-US');
    const months = [];
    for (let i = 0; i < 12; i++) {
      const monthDate = new Date(2000, i, 1); // year and day don't matter
      const monthName = datePipe.transform(monthDate, 'MMMM');
      const translatedMonthName = this.commonService.translate.instant(`MONTHS.${monthName}`);
      months.push(translatedMonthName);
    }
    return months;
  }

  // Methor for getYears
  getYears(): number[] {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear - 13; i >= currentYear - 90; i--) {
      years.push(i);
    }
    return years;
  }


  public isFieldInvalid(fieldName: string): boolean {
    const control = this.joinForm.get(fieldName);
    return !!(control && control.invalid && (control.touched || control.dirty));
  }

  strongPasswordValidator(control: AbstractControl): { [key: string]: any } | null {
    const password = control.value || '';

    // Call the same service method used in UI feedback
    this.commonService.userService.checkPasswordStrength(password);

    const { hasLetter, hasNumber, hasSpecialChar, hasMinLength, hasSpace } = this.commonService.userService;

    const isValid = hasLetter && hasNumber && hasSpecialChar && hasMinLength && !hasSpace;

    return isValid ? null : { strongPassword: true };
  }


  valueChangePassword() {
    this.passwordField.valueChanges.subscribe(password => {
      this.commonService.userService.checkPasswordStrength(password);
      this.passwordStrength = {
        hasLetter: this.commonService.userService.hasLetter,
        hasNumber: this.commonService.userService.hasNumber,
        hasSpecialChar: this.commonService.userService.hasSpecialChar,
        hasMinLength: this.commonService.userService.hasMinLength,
        hasSpace: this.commonService.userService.hasSpace
      };
      if (this.passwordStrength.hasLetter && this.passwordStrength.hasNumber && this.passwordStrength.hasSpecialChar && this.passwordStrength.hasMinLength && !this.passwordStrength.hasSpace) {
        this.showCriteria = false;
      } else {
        this.showCriteria = true;
      }
    });
  }

  zipCodeError() {
    const zipValue = this.joinForm.value.zipCode.replace(/\s/g, "")
    const zipBody = {
      trafficId: this.trafficId,
      zipCode: zipValue,
      email: this.joinForm.value.email
    }
    this.commonService.httpApiService.post(userApi.updateTraffic, zipBody).then((res) => {
    }).catch((error) => {
    })
  }

  readInput() {
    let firstName = this.joinForm.get('firstName').value
    let lastName = this.joinForm.get('lastName').value;
    if (firstName.length > 50) {
      this.joinForm.patchValue({
        firstName: firstName.slice(0, 50)
      })
    }
    if (lastName.length > 50) {
      this.joinForm.patchValue({
        lastName: firstName.slice(0, 50)
      })
    }
  }

  validatePromo(): void {
    const promoCode = this.joinForm.get('promoCode')?.value?.replace(/\s+/g, '');
    if (!promoCode) {
      this.isBlankPromo = true;
      return;
    }

    this.resetPromoState();
    this.isValidate = true;

    this.commonService.httpApiService
      .get(`${userApi.verifyPromoCode}?promoCode=${promoCode}`)
      .then((res: any) => this.handlePromoSuccess(res))
      .catch((err) => this.handlePromoError(err))
      .finally(() => {
        this.isValidate = false;
      });
  }

  private handlePromoSuccess(res: any): void {
    this.isPromoSuccess = true;
    this.promoAmount = res?.amount;
  }

  private handlePromoError(err: any): void {
    const statusCode = err?.statusCode;
    const mapStatusCode = this.getMappedStatusCode(err);

    this.isPromoInvalid = true;

    if (statusCode) {
      this.commonService.translate
        .get(mapStatusCode)
        .subscribe(msg => this.commonService.userService.showError(msg));
    } else {
      this.commonService.translate
        .get('somethingWentWrong')
        .subscribe(msg => this.commonService.userService.showError(msg));
    }

    setTimeout(() => {
      this.resetPromoState();
    }, 3000);
  }

  private resetPromoState(): void {
    this.isBlankPromo = false;
    this.isPromoSuccess = false;
    this.isPromoInvalid = false;
  }



  handleInput(event) {
    const input = event.target as HTMLInputElement;

    let value = input.value.replace(/\s+/g, '');

    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    input.value = value;
    this.joinForm.get('promoCode')?.setValue(value, { emitEvent: false });

    this.isBlankPromo = false;
  }

  async getCulture() {
    const item = await this.sharedService.getculter()
    item.pipe(filter((res: any) => !!res?.culture)).subscribe((res: any) => {
      this.cultureLanguage = res.culture?.split('-')[0] || 'en';
    })
  }

  onVerified(captchaResponse: string) {
    // This method is called when reCAPTCHA is successfully completed
    this.joinForm.get('reCaptcha')?.setValue(captchaResponse);
  }

  handleError() {
    // This method is called when reCAPTCHA fails
    this.joinForm.get('reCaptcha')?.reset();
  }

  onExpired() {
    // This method is called when reCAPTCHA expires
    this.joinForm.get('reCaptcha')?.reset();
  }
}
